import { render, staticRenderFns } from "./EventDetailsPopup.vue?vue&type=template&id=79482544&scoped=true"
import script from "./EventDetailsPopup.vue?vue&type=script&lang=js"
export * from "./EventDetailsPopup.vue?vue&type=script&lang=js"
import style0 from "./EventDetailsPopup.vue?vue&type=style&index=0&id=79482544&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79482544",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79482544')) {
      api.createRecord('79482544', component.options)
    } else {
      api.reload('79482544', component.options)
    }
    module.hot.accept("./EventDetailsPopup.vue?vue&type=template&id=79482544&scoped=true", function () {
      api.rerender('79482544', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EventDetailsPopup.vue"
export default component.exports